import React from 'react';

import './certificate-modal__form-field-wrap.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
}

export const CertificateModalFormFieldWrap = ({ children }: Props) => (
    <div className="certificate-modal__form-field-wrap">{children}</div>
);
